module.exports = __webpack_public_path__ + "img/swiper_bg2.d6c8a0d0.png";